import ActionTypes from '../../../constants/ActionTypes';
import {commonReducers as common} from '@gisatcz/ptr-state';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case ActionTypes.INSAR.TYPES.SET_ACTIVE_KEY:
			return common.setActive(state, action);
		case ActionTypes.INSAR.TYPES.UPDATE_STORE:
			return common.updateStore(state, action);
		default:
			return state;
	}
};
